import { InvoiceStatus } from "@/api/invoices"
import { Badge } from "@/components/ui/badge"

const getBadgeVariant = (status: InvoiceStatus) => {
  switch (status) {
    case InvoiceStatus.DRAFT:
      return "gray"
    case InvoiceStatus.PENDING:
      return "yellow"
    case InvoiceStatus.PAID:
      return "green"
  }
}

export default function InvoiceBadge({ status }: { status: InvoiceStatus }) {
  return (
    <Badge variant={getBadgeVariant(status)} className="capitalize">
      {status.toLowerCase()}
    </Badge>
  )
}
